<h1 class="modal-title">Select Fund on Hold</h1>

<div class="table-container">
  <rkt-table
    [rows]="(fundsOnHold$ | async) ?? []"
    [columns]="columns"
    [class.no-pagination]="((fundsOnHold$ | async)?.length ?? 0) < 5"
    [loadingIndicator]="(isLoading$ | async) ?? false"
    [stickyHeader]="false"
    [rowHeight]="64"
    [placeholderItemsCount]="5"
    [isItemsAlignCenter]="true"
    [messages]="{ emptyMessage: 'No Funds on Hold available.' }"
    emptyValuePlaceholder="--"
    [selected]="selectedFoh"
    [selectionType]="selectionType"
    (rowSelected)="onFohSelect($event)"
    [footerHeight]="0"
    [externalPaging]="false"
    dateTimeFormat="MM/dd/yy HH:mm"
  ></rkt-table>
</div>

<div class="modal-buttons">
  <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
  <button rktButton type="submit" (click)="onSelectBtnClick()" [disabled]="!selectedFoh.length" title="Select Fund on Hold">Select</button>
</div>
